import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useUserItemFetch = (id: string) => {
  const response = useQuery({
    queryKey: ['userItem', id],
    queryFn: () => api.keycloak.fetchUserItem(id),
    enabled: !!id, // Запрос выполняется только если есть id
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить данные пользователя',
      type: 'error',
      duration: 9000,
      isClosable: true,
    })
  }

  return response
}
